import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Holdeo } from '@shared/models/facturacion/Holdeo';
import { MessageService } from '@shell/message.service';
import { ComprobanteService } from '../../comprobante.service';
import { NuevoHoldeoComponent } from '../nuevo-holdeo/nuevo-holdeo.component';
import { TipoHoldeo } from '@shared/enums/TipoHoldeo';

@Component({
  selector: 'app-holdeo-cuentas',
  templateUrl: './holdeo-cuentas.component.html',
  styleUrls: ['./holdeo-cuentas.component.css']
})
export class HoldeoCuentasComponent implements OnInit {

  @Output() volver = new EventEmitter();

  cuentasHoldeadas: Holdeo[];
  obteniendo: boolean = false;
  desactivandoCuenta: boolean = false;
  cuentaSeleccionada: number;

  constructor(private activeModal: NgbModal, private comprobantesService: ComprobanteService, private spinner: NgxSpinnerService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.getHoldeoCuenta();
  }

  agregarCuenta(){
    const modalRef = this.activeModal.open(NuevoHoldeoComponent, {centered: true, backdrop: 'static'});
    modalRef.componentInstance.tipo = 1;
    modalRef.result.then(result =>{
      result == true ? this.ngOnInit() : null;
    });
  }

  getHoldeoCuenta(){
    this.spinner.show('spinnerLista');
    this.obteniendo = true;
    this.comprobantesService.getHoldeo(4, TipoHoldeo.CuentaCliente)
      .subscribe(result => {
        this.cuentasHoldeadas = result;
        this.spinner.hide('spinnerLista');
        this.obteniendo = false;
      });
  }

  quitarCuentas(i: number){
    this.desactivandoCuenta = true;
    this.cuentaSeleccionada = i;
    this.cuentasHoldeadas[i].activo = !this.cuentasHoldeadas[i].activo;
    this.comprobantesService.putHoldeo(this.cuentasHoldeadas[i])
      .subscribe(result => {
        this.messageService.showSuccessMessage(`El holdeo de la cuenta fue ${result.activo ? 'activado' : 'desactivado'} con éxito`);
        this.getHoldeoCuenta();
        this.desactivandoCuenta = false;
        this.cuentaSeleccionada = null;
      }, () => {
        this.messageService.showErrorMessage('Hubo un error al actualizar el estado de la cuenta');
        this.desactivandoCuenta = false;
        this.cuentaSeleccionada = null;
      });
  }

  goBack(){
    this.volver.emit(true);
  }
}
